import { CommonPalette } from 'styled-components';
export const commonPalette: CommonPalette = {
  palette: {
    brand: '#6264A7',
    primary50: '#F2EFF4', //ultraLight
    primary600: '#4B286D', //main
    neutral100: '#2C2E30',
    neutral75: '#424547', //mk2
  },
};
